import type { FC, ReactNode } from 'react'
import type { ArticleSummary } from '@/types'

import { Reveal } from '@/components/motion/reveal'
import { ArrowLink } from '@/components/site/arrow-link'
import { JournalCard } from '@/components/site/journal-card'
import { SectionHeading } from '@/components/site/section-heading'

interface HomeJournalProps {
    articles: ArticleSummary[]
}

export const HomeJournal: FC<HomeJournalProps> = ({ articles }): ReactNode => {
    return (
        <section
            id='journal'
            className='relative z-[2] flex w-full flex-col overflow-clip bg-background px-4 py-section-sm lg:px-6'
        >
            <div className='flex w-full items-start justify-center gap-6'>
                <div className='relative z-[2] flex-1'>
                    <SectionHeading lead="From the" title="journal" />
                </div>

                <div className='hidden max-w-[32%] flex-1 flex-col items-end justify-end self-stretch py-6 md:flex'>
                    <div className='flex flex-col items-end py-6 pl-6'>
                        <ArrowLink href='/journal' label="Read the journal" />
                    </div>
                </div>
            </div>

            <div className='flex w-full flex-col gap-12 pt-4 md:flex-row md:gap-6 lg:gap-8 lg:pt-6'>
                {articles.map((article, index) => (
                    <Reveal key={article.id} className='w-full md:flex-1' delay={index * 0.08}>
                        <JournalCard article={article} />
                    </Reveal>
                ))}
            </div>

            <div className='flex w-full justify-center py-6 md:hidden'>
                <ArrowLink href='/journal' label="Read the journal" />
            </div>
        </section>
    )
}
